import { render } from "./right.vue?vue&type=template&id=63e6a447&scoped=true"
import script from "./right.vue?vue&type=script&lang=js"
export * from "./right.vue?vue&type=script&lang=js"

import "./right.vue?vue&type=style&index=0&id=63e6a447&scoped=scoped&lang=css"
script.render = render
script.__scopeId = "data-v-63e6a447"

export default script